import axios from 'axios'
import {getApiUrls} from "@/http/base.http";

export function ddRoot() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/archival/dest/root/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddFolder(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/archival/dest/folder/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddFile(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/archival/graph/file/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddHub() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/archival/hub/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddController(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/archival/controller/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddDevice(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/archival/device/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getDeviceGraphData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/device/graph/get`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}


